import { cn } from "@-/com.npmjs.cn";
import type { ComponentProps } from "react";
import { websiteContainerVariants } from "#website-container-variants";

/**
 * The website's content column. Constrain long-form text inside it with a `max-w-*` so it stays
 * aligned with the page header.
 */
export function WebsiteContainer({ className, ...props }: ComponentProps<"div">) {
  return <div className={cn(websiteContainerVariants(), className)} {...props} />;
}
